
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { create, reduce, State_$reflection as State_$reflection_1, Msg_$reflection as Msg_$reflection_1 } from "./Aufgaben/BruchKuerzen.jsx";
import { create as create_1, reduce as reduce_1, State_$reflection as State_$reflection_2, Msg_$reflection as Msg_$reflection_2 } from "./Aufgaben/BruchZuDezimal.jsx";
import { create as create_2, reduce as reduce_2, State_$reflection as State_$reflection_3, Msg_$reflection as Msg_$reflection_3 } from "./Aufgaben/Konvertieren.jsx";
import { record_type, option_type, int32_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { TaskResultMsg_$reflection } from "./Types.jsx";
import { nonSeeded } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Random.js";
import { item } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Array.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";

export class TaskMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BruchKuerzenMsg", "BruchZuDezimalMsg", "KonvertierenMsg"];
    }
}

export function TaskMsg_$reflection() {
    return union_type("MatheApp.Domain.Root.TaskMsg", [], TaskMsg, () => [[["Item", Msg_$reflection_1()]], [["Item", Msg_$reflection_2()]], [["Item", Msg_$reflection_3()]]]);
}

export class TaskState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BruchKuerzenState", "BruchZuDezimalState", "KonvertierenState"];
    }
}

export function TaskState_$reflection() {
    return union_type("MatheApp.Domain.Root.TaskState", [], TaskState, () => [[["Item", State_$reflection_1()]], [["Item", State_$reflection_2()]], [["Item", State_$reflection_3()]]]);
}

export class Url extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "SpecificTask"];
    }
}

export function Url_$reflection() {
    return union_type("MatheApp.Domain.Root.Url", [], Url, () => [[], [["Item", string_type]]]);
}

export class Feedback extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoFeedback", "Korrekt", "Falsch"];
    }
}

export function Feedback_$reflection() {
    return union_type("MatheApp.Domain.Root.Feedback", [], Feedback, () => [[], [], []]);
}

export class State extends Record {
    constructor(GlobalScore, CurrentTask, Feedback) {
        super();
        this.GlobalScore = (GlobalScore | 0);
        this.CurrentTask = CurrentTask;
        this.Feedback = Feedback;
    }
}

export function State_$reflection() {
    return record_type("MatheApp.Domain.Root.State", [], State, () => [["GlobalScore", int32_type], ["CurrentTask", option_type(TaskState_$reflection())], ["Feedback", Feedback_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskMsg", "TaskResult", "StartNextTask", "StartSpecificTask", "ClearFeedback"];
    }
}

export function Msg_$reflection() {
    return union_type("MatheApp.Domain.Root.Msg", [], Msg, () => [[["Item", TaskMsg_$reflection()]], [["Item", TaskResultMsg_$reflection()]], [], [["Item", string_type]], []]);
}

const random = nonSeeded();

export function taskReduce(logger, state, msg) {
    const r = (factory, reducer, taskState, taskMsg) => {
        const patternInput = reducer(logger)(taskState)(taskMsg);
        return [factory(patternInput[0]), patternInput[1]];
    };
    let matchResult, taskMsg_1, taskState_1, taskMsg_2, taskState_2, taskMsg_3, taskState_3;
    switch (state.tag) {
        case 1: {
            if (msg.tag === 1) {
                matchResult = 1;
                taskMsg_2 = msg.fields[0];
                taskState_2 = state.fields[0];
            }
            else {
                matchResult = 3;
            }
            break;
        }
        case 2: {
            if (msg.tag === 2) {
                matchResult = 2;
                taskMsg_3 = msg.fields[0];
                taskState_3 = state.fields[0];
            }
            else {
                matchResult = 3;
            }
            break;
        }
        default:
            if (msg.tag === 0) {
                matchResult = 0;
                taskMsg_1 = msg.fields[0];
                taskState_1 = state.fields[0];
            }
            else {
                matchResult = 3;
            }
    }
    switch (matchResult) {
        case 0:
            return r((Item) => (new TaskState(0, [Item])), (logger_1) => ((state_1) => ((action) => reduce(logger_1, state_1, action))), taskState_1, taskMsg_1);
        case 1:
            return r((Item_1) => (new TaskState(1, [Item_1])), (logger_2) => ((state_2) => ((action_1) => reduce_1(logger_2, state_2, action_1))), taskState_2, taskMsg_2);
        case 2:
            return r((Item_2) => (new TaskState(2, [Item_2])), (logger_3) => ((state_3) => ((action_2) => reduce_2(logger_3, state_3, action_2))), taskState_3, taskMsg_3);
        default: {
            logger("Received TaskMsg for unsupported or no current task.");
            return [state, undefined];
        }
    }
}

export function update(logger_mut, msg_mut, state_mut) {
    update:
    while (true) {
        const logger = logger_mut, msg = msg_mut, state = state_mut;
        let matchResult, taskType, taskMsg, taskState;
        switch (msg.tag) {
            case 2: {
                matchResult = 0;
                break;
            }
            case 3: {
                matchResult = 1;
                taskType = msg.fields[0];
                break;
            }
            case 0: {
                if (state.CurrentTask != null) {
                    matchResult = 2;
                    taskMsg = msg.fields[0];
                    taskState = state.CurrentTask;
                }
                else {
                    matchResult = 4;
                }
                break;
            }
            case 4: {
                matchResult = 3;
                break;
            }
            default:
                matchResult = 4;
        }
        switch (matchResult) {
            case 0: {
                const tasks = [new TaskState(0, [create(random)]), new TaskState(1, [create_1(random)]), new TaskState(2, [create_2(random)])];
                return new State(state.GlobalScore, item(random.Next1(tasks.length), tasks), new Feedback(0, []));
            }
            case 1: {
                let task;
                const matchValue_1 = taskType.toLowerCase();
                switch (matchValue_1) {
                    case "bruchkuerzen": {
                        task = (new TaskState(0, [create(random)]));
                        break;
                    }
                    case "bruchzudezimal": {
                        task = (new TaskState(1, [create_1(random)]));
                        break;
                    }
                    case "konvertieren": {
                        task = (new TaskState(2, [create_2(random)]));
                        break;
                    }
                    default: {
                        logger(concat("Unknown task type: ", taskType, ...", starting random task."));
                        task = undefined;
                    }
                }
                if (task == null) {
                    logger_mut = logger;
                    msg_mut = (new Msg(2, []));
                    state_mut = state;
                    continue update;
                }
                else {
                    return new State(state.GlobalScore, task, new Feedback(0, []));
                }
            }
            case 2: {
                const patternInput = taskReduce(logger, taskState, taskMsg);
                const msg_1 = patternInput[1];
                let newState;
                const inputRecord_2 = state;
                newState = (new State(inputRecord_2.GlobalScore, patternInput[0], inputRecord_2.Feedback));
                if (msg_1 != null) {
                    switch (msg_1.tag) {
                        case 1:
                            return new State(newState.GlobalScore + 1, newState.CurrentTask, new Feedback(1, []));
                        case 0: {
                            logger_mut = logger;
                            msg_mut = (new Msg(2, []));
                            state_mut = newState;
                            continue update;
                        }
                        default: {
                            const inputRecord_3 = newState;
                            return new State(inputRecord_3.GlobalScore, inputRecord_3.CurrentTask, new Feedback(2, []));
                        }
                    }
                }
                else {
                    return newState;
                }
            }
            case 3: {
                const inputRecord_5 = state;
                return new State(inputRecord_5.GlobalScore, inputRecord_5.CurrentTask, new Feedback(0, []));
            }
            default:
                return state;
        }
        break;
    }
}

export const initialState = new State(0, undefined, new Feedback(0, []));

